// You can write more code here

import { getArticulatoryGestures } from '@/common/utils/scopeAndSequence';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { HorizontalLayoutGroup } from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/HorizontalLayoutGroup';
import { SizedElement } from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/LayoutGroupUtils';
import {
  getArticulatoryGestureTexture,
  waitForSeconds,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';

/* START OF COMPILED CODE */

export default class ArticulatoryGesture
  extends Phaser.GameObjects.Image
  implements SizedElement
{
  constructor(
    scene: Phaser.Scene,
    x?: number,
    y?: number,
    texture?: string,
    frame?: number | string,
  ) {
    super(scene, x ?? 0, y ?? 0, texture || 'b_1', frame);

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  getElementSize() {
    return new Phaser.Math.Vector2(this.displayWidth, this.displayHeight);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

export async function createArticulatoryGesture(
  scene: Phaser.Scene,
  x: number,
  y: number,
  gesture?: string,
) {
  if (!gesture || gesture === '∅') {
    return;
  }
  const parentContainer = scene.add.container(x, y);

  const gestures = getArticulatoryGestures(gesture);
  const layoutGroupContainer = scene.add.container(0, 0);
  const layoutGroup = new HorizontalLayoutGroup({
    parent: layoutGroupContainer,
    origin: new Phaser.Math.Vector2(0.5, 0.5),
    elementDist: 8,
    align: 'center',
  });

  parentContainer.setVisible(true);
  parentContainer.add(layoutGroupContainer);
  layoutGroupContainer.y = 50;

  // Container tweens.
  // Fade in.
  parentContainer.setAlpha(0);
  scene.tweens.add({
    targets: parentContainer,
    alpha: 1,
    duration: 400,
    ease: 'Cubic.easeOut',
  });
  scene.tweens.add({
    targets: parentContainer,
    alpha: 0,
    duration: 400,
    ease: 'Cubic.easeOut',
    delay: 800,
  });

  const endY = ResponsivenessManager.IsMobileDevice(parentContainer.scene)
    ? 25
    : 0;
  scene.tweens.add({
    targets: layoutGroupContainer,
    y: endY,
    duration: 400,
    ease: 'Cubic.easeOut',
  });

  // Fade out.
  scene.tweens.add({
    targets: layoutGroupContainer,
    y: 200,
    duration: 400,
    ease: 'Cubic.easeOut',
    delay: 1400,
  });

  layoutGroup?.data.parent.removeAll(true);
  for (const gesture of gestures) {
    const newGestureObj = new ArticulatoryGesture(scene, 0, 0);
    const isMobile = ResponsivenessManager.IsMobileDevice(newGestureObj.scene);
    newGestureObj.setScale(isMobile ? 0.35 : 0.65);
    scene.add.existing(newGestureObj);
    layoutGroup?.data.parent.add(newGestureObj);
    newGestureObj.setTexture(getArticulatoryGestureTexture(gesture));
  }
  layoutGroup?.updateLayout();
  await waitForSeconds(scene.time, 1.2);

  parentContainer.destroy();
}
